"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _BannerModule = _interopRequireDefault(require("./Banner.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Banner = props => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
  variant: "h1",
  className: _BannerModule.default['site-name']
}, /*#__PURE__*/_react.default.createElement(_material.Link, {
  className: _BannerModule.default['site-name-link'],
  href: props.href
}, props.children)), /*#__PURE__*/_react.default.createElement(_material.Hidden, {
  mdDown: true,
  lgUp: !props.subtitle
}, /*#__PURE__*/_react.default.createElement(_material.Typography, {
  variant: "subtitle1",
  component: "span"
}, props.subtitle)));
Banner.defaultProps = {
  href: '/'
};
var _default = exports.default = Banner;